import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import './filter.css';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FilterEvents = ({ onFilterChange, show = false }) => {
  const [selected, setSelected] = useState('ALL');
  const history = useHistory();
  const reservationType = 'TICKETS';
  const { t } = useTranslation();

  const filters = [
    { id: 'ALL', name: t('filterCustomer.all'), show: true },
    { id: 'UPCOMING', name: t('filterCustomer.upcoming'), show: true },
    { id: 'TODAY', name: t('filterCustomer.tonight'), show: show },
    { id: 'DATEPICK', name: t('filterCustomer.datePick'), show: show },
  ];

  useEffect(() => {
    if (onFilterChange) onFilterChange({ id: 'ALL' });
  }, []);

  const handleFilterClick = (filter) => {
    setSelected(filter ? filter.id : null);

    if (filter.id === 'DATEPICK') {
      history.push({
        pathname: reservationType === 'restaurant' ? '/reservation-restaurant' : '/event-selector',
        search: `?showId=${1274}`,
      });
    } else {
      if (onFilterChange) onFilterChange(filter);
    }
  };

  return (
    <div>
      <Swiper spaceBetween={10} slidesPerView={'auto'}>
        {filters.map((filter, index) => (
          <SwiperSlide key={index}>
            <button
              className={`button-filter pl-3 pr-3 ${
                selected === filter.id ? 'active' : ''
              } filter-${filter.id}`}
              onClick={() => handleFilterClick(filter)}
              style={{ display: filter.show ? 'block' : 'none' }}
            >
              {filter.name}
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default FilterEvents;
